import { Button, Tooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamation } from "@fortawesome/free-solid-svg-icons";
import type { TooltipProps } from "reactstrap";

type Props = {
  hasWarnings: boolean;
  canShowWarnings: boolean;
  showAllWarnings: () => void;
  commonTooltipProps: Pick<TooltipProps, "placement" | "container" | "modifiers">;
  tooltipOpen: { seasons: boolean; display: boolean };
  toggleTooltip: (k: keyof Props["tooltipOpen"]) => void;
};

export function WarningButton({
  hasWarnings,
  canShowWarnings,
  showAllWarnings,
  commonTooltipProps,
  tooltipOpen,
  toggleTooltip,
}: Props) {
  return (
    <>
      <Button
        id="btnWarningDisplay"
        aria-label="Display All Over-Limit Values"
        outline={!hasWarnings}
        color={hasWarnings ? "danger" : "secondary"}
        className="border-0 shadow-none px-2 ml-2 mr-1"
        size="sm"
        onClick={showAllWarnings}
        disabled={!canShowWarnings}
      >
        <FontAwesomeIcon icon={faExclamation} />
      </Button>

      <Tooltip
        isOpen={tooltipOpen.display}
        target="btnWarningDisplay"
        toggle={() => toggleTooltip("display")}
        {...commonTooltipProps}
      >
        Display all over limit values
      </Tooltip>
    </>
  );
}
